"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ProximityBase_1 = require('./ProximityBase');
/**
 * A {@code RadiusProximity} elaborates any agents contained in the specified list that are within the radius of the owner.
 * <p>
 * Note that this implementation checks the AI time of the current frame through the {@link Timepiece#getTime()
 * GdxAI.getTimepiece().getTime()} method in order to calculate neighbors only once per frame (assuming delta time is always
 * greater than 0, if time has changed the frame has changed too). This means that
 * <ul>
 * <li>if you forget to {@link Timepiece#update(float) update the timepiece} on each frame the proximity instance will be
 * calculated only the very first time, which is not what you want of course.</li>
 * <li>ideally the timepiece should be updated before the proximity is updated by the {@link #findNeighbors(ProximityCallback)}
 * method.</li>
 * </ul>
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var RadiusProximity = (function (_super) {
    __extends(RadiusProximity, _super);
    /**
     * Creates a {@code RadiusProximity} for the specified owner, agents and radius.
     * @param owner the owner of this proximity
     * @param agents the agents
     * @param radius the radius of the cone area
     */
    function RadiusProximity(owner, agents, radius, getTickId) {
        _super.call(this, owner, agents);
        this.radius = radius;
        this.lastTime = 0;
        this.getTickId = getTickId;
    }
    /** Returns the radius of this proximity. */
    RadiusProximity.prototype.getRadius = function () {
        return this.radius;
    };
    /** Sets the radius of this proximity. */
    RadiusProximity.prototype.setRadius = function (radius) {
        this.radius = radius;
    };
    RadiusProximity.prototype.findNeighbors = function (callback) {
        var neighborCount = 0;
        // If the frame is new then avoid repeating calculations
        // when this proximity is used by multiple group behaviors.
        var currentTime = this.getTickId();
        if (this.lastTime !== currentTime) {
            // Save the current time
            this.lastTime = currentTime;
            var ownerPosition = this.owner.getPosition();
            // Scan the agents searching for neighbors
            for (var _i = 0, _a = this.agents; _i < _a.length; _i++) {
                var currentAgent = _a[_i];
                // Make sure the agent being examined isn't the owner
                if (currentAgent !== this.owner) {
                    var squareDistance = ownerPosition.dst2(currentAgent.getPosition());
                    // The bounding radius of the current agent is taken into account
                    // by adding it to the range
                    var range = this.radius + currentAgent.getBoundingRadius();
                    // If the current agent is within the range, report it to the callback
                    // and tag it for further consideration.
                    if (squareDistance < range * range) {
                        if (callback.reportNeighbor(currentAgent)) {
                            currentAgent.setTagged(true);
                            neighborCount++;
                            continue;
                        }
                    }
                }
                // Clear the tag
                currentAgent.setTagged(false);
            }
        }
        else {
            // Scan the agents searching for tagged neighbors
            for (var _b = 0, _c = this.agents; _b < _c.length; _b++) {
                var currentAgent = _c[_b];
                // Make sure the agent being examined isn't the owner and that
                // it's tagged.
                if (currentAgent !== this.owner && currentAgent.isTagged()) {
                    if (callback.reportNeighbor(currentAgent)) {
                        neighborCount++;
                    }
                }
            }
        }
        return neighborCount;
    };
    return RadiusProximity;
}(ProximityBase_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RadiusProximity;
//# sourceMappingURL=RadiusProximity.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/proximities/RadiusProximity.js
 ** module id = 897
 ** module chunks = 0
 **/